import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    marginTop: "15px",
  },

  text: {
    fontWeight: "400 !important",
    fontSize: "22px !important",
  },
}));
